import { AnyObject } from 'antd/es/_util/type'

export enum ElementType {
  INPUT = 'Input',
  RADIO = 'Radio',
  DATE = 'Date',
  DATETIME = 'DateTime',
  SELECT = 'Select',
  FILE = 'File',
  TEXTAREA = 'Textarea',
  CHECKBOX = 'Checkbox',
  OPERATOR = 'Operator',
  VALUE = 'Value',
  NUMBER = 'Number'
}

export interface TaskFormElement {
  type: ElementType
  name: string
  label: string
  props: AnyObject
}

export interface TaskType {
  id: number
  name: string
  code: string
  form: TaskFormElement[]
  created_at: string
  modified_at: string
}
